(function () {
  const initTestimonials = (section) => {
    if (!section || !section.classList.contains("testimonials-section")) {
      return;
    }

    const sliderEl = section.querySelector(".section-card-slider");
    if (!sliderEl) return;

    function initVideoPlayers() {
      const videoBlocks = sliderEl.querySelectorAll(
        ".testimonials-card-slideshow-slide__media-video-block"
      );
      videoBlocks.forEach((videoBlock) => {
        const video = videoBlock.querySelector("video");
        const playIcon = videoBlock.querySelector(
          ".testimonials-card-slideshow-slide__media-video-block-play-icon"
        );
        const leftCornerControls = videoBlock.querySelector(
          ".testimonials-card-slideshow-slide__media-left-corner-controls"
        );
        const leftCornerPauseIcon = videoBlock.querySelector(
          ".testimonials-card-slideshow-slide__media-left-corner-controls .left-corner-controls-pause"
        );
        const leftCornerPlayIcon = videoBlock.querySelector(
          ".testimonials-card-slideshow-slide__media-left-corner-controls .left-corner-controls-play"
        );
        if (!video || !playIcon) return;

        if (
          (leftCornerPlayIcon &&
            !leftCornerPlayIcon.querySelector(".video-progress-container")) ||
          (leftCornerPauseIcon &&
            !leftCornerPauseIcon.querySelector(".video-progress-container"))
        ) {
          leftCornerPauseIcon.insertAdjacentHTML(
            "beforeend",
            `
            <div class="video-progress-container" style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 100%;
              height: 100%;
              pointer-events: none;
            ">
              <svg style="
                width: 100%;
                height: 100%;
                transform: rotate(-90deg);
              " viewBox="0 0 100 100">
                <circle cx="50" cy="50" r="42" fill="none" stroke="rgba(255,255,255,0.3)" stroke-width="5"/>
                <circle class="progress-fill" cx="50" cy="50" r="42" fill="none" stroke="currentColor" stroke-width="5" 
                        stroke-dasharray="264" stroke-dashoffset="264" stroke-linecap="round"/>
              </svg>
            </div>
          `
          );
          leftCornerPlayIcon.insertAdjacentHTML(
            "beforeend",
            `
            <div class="video-progress-container" style="
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 100%;
              height: 100%;
              pointer-events: none;
            ">
              <svg style="
                width: 100%;
                height: 100%;
                transform: rotate(-90deg);
              " viewBox="0 0 100 100">
                <circle cx="50" cy="50" r="42" fill="none" stroke="rgba(255,255,255,0.3)" stroke-width="5"/>
                <circle class="progress-fill" cx="50" cy="50" r="42" fill="none" stroke="currentColor" stroke-width="5" 
                        stroke-dasharray="264" stroke-dashoffset="264" stroke-linecap="round"/>
              </svg>
            </div>
          `
          );
        }

        const progressFill =
          leftCornerPauseIcon?.querySelector(".progress-fill");
        const progressFillPlay =
          leftCornerPlayIcon?.querySelector(".progress-fill");
        const circumference = 264;
        let animationId = null;

        const playLabel = playIcon.getAttribute("aria-label") || "Play video";
        const pauseLabel =
          leftCornerControls?.dataset.pauseLabel || "Pause video";

        function updateControlLabels() {
          if (!leftCornerControls) return;
          leftCornerControls.setAttribute(
            "aria-label",
            video.paused ? playLabel : pauseLabel
          );
        }

        function updateProgress() {
          if (!video.paused && !video.ended && video.duration) {
            const progress = video.currentTime / video.duration;
            const offset = circumference * (1 - progress);
            if (progressFill) progressFill.style.strokeDashoffset = offset;
            if (progressFillPlay)
              progressFillPlay.style.strokeDashoffset = offset;
            animationId = requestAnimationFrame(updateProgress);
          }
        }

        function resetProgress() {
          if (progressFill) progressFill.style.strokeDashoffset = circumference;
          if (progressFillPlay)
            progressFillPlay.style.strokeDashoffset = circumference;
          if (animationId) {
            cancelAnimationFrame(animationId);
            animationId = null;
          }
        }

        function hidePlayIcon() {
          playIcon.style.opacity = "0";
          playIcon.style.visibility = "hidden";
          playIcon.setAttribute("tabindex", "-1");
          playIcon.setAttribute("aria-hidden", "true");
        }

        function showPlayIcon() {
          playIcon.style.opacity = "1";
          playIcon.style.visibility = "visible";
          playIcon.removeAttribute("tabindex");
          playIcon.removeAttribute("aria-hidden");
        }

        playIcon.addEventListener("click", (e) => {
          e.stopPropagation();

          const allVideos = sliderEl.querySelectorAll("video");
          allVideos.forEach((otherVideo) => {
            if (otherVideo !== video && !otherVideo.paused) {
              otherVideo.pause();
            }
          });

          video.play().catch((error) => {
            console.log("Video playback failed:", error);
          });

          const playIconHadFocus = playIcon.contains(document.activeElement);
          hidePlayIcon();

          if (playIconHadFocus && leftCornerControls) {
            leftCornerControls.removeAttribute("tabindex");
            leftCornerControls.removeAttribute("aria-hidden");
            leftCornerControls.focus();
          }
        });

        video.addEventListener("click", () => {
          hidePlayIcon();

          const allVideos = sliderEl.querySelectorAll("video");
          allVideos.forEach((otherVideo) => {
            if (otherVideo !== video && !otherVideo.paused) {
              otherVideo.pause();
            }
          });

          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        });

        if (leftCornerControls) {
          leftCornerControls.addEventListener("click", (e) => {
            e.stopPropagation();

            const allVideos = sliderEl.querySelectorAll("video");
            allVideos.forEach((otherVideo) => {
              if (otherVideo !== video && !otherVideo.paused) {
                otherVideo.pause();
              }
            });

            if (video.paused) {
              hidePlayIcon();
              video.play().catch((error) => {
                console.log("Video playback failed:", error);
              });
            } else {
              video.pause();
            }
          });
        }

        video.addEventListener("ended", () => {
          const controlsHadFocus =
            leftCornerControls?.contains(document.activeElement) || false;

          showPlayIcon();
          leftCornerPauseIcon.style.display = "none";
          leftCornerPlayIcon.style.display = "none";
          if (leftCornerControls) {
            leftCornerControls.setAttribute("tabindex", "-1");
            leftCornerControls.setAttribute("aria-hidden", "true");
          }
          updateControlLabels();
          resetProgress();

          if (controlsHadFocus) {
            playIcon.focus();
          }
        });

        video.addEventListener("play", () => {
          leftCornerPauseIcon.style.display = "block";
          leftCornerPlayIcon.style.display = "none";
          if (leftCornerControls) {
            leftCornerControls.removeAttribute("tabindex");
            leftCornerControls.removeAttribute("aria-hidden");
          }
          updateControlLabels();
          updateProgress();
        });

        video.addEventListener("pause", () => {
          leftCornerPauseIcon.style.display = "none";
          leftCornerPlayIcon.style.display = "block";
          if (leftCornerControls) {
            leftCornerControls.removeAttribute("tabindex");
            leftCornerControls.removeAttribute("aria-hidden");
          }
          updateControlLabels();
          if (animationId) {
            cancelAnimationFrame(animationId);
            animationId = null;
          }
        });

        video.addEventListener("loadedmetadata", () => {
          resetProgress();
        });

        if (leftCornerControls) {
          leftCornerControls.setAttribute("tabindex", "-1");
          leftCornerControls.setAttribute("aria-hidden", "true");
        }
        updateControlLabels();
      });
    }
    initVideoPlayers();
  };

  initTestimonials(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initTestimonials(event.target);
  });
})();
